import { Location } from '@app/shared/routes';

const DashboardLocation = new Location({ path: '/dashboard' });

export { DashboardLocation };
